//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../Fields/Fields.Field.js";
let d=[[[0,"CombineTable",1,0]],[[["indep_var_array","dep_exp_array"],"EditFieldFormula",{},2,0],[["indep_var_array","dep_var_array"],"EditFieldFormulaVariables",{},2,0],[["num_dep_exps"],"GetDependentExpressions",{R_:{dependent_expressions:"Fields.FieldExpression[]"}},0,0]],[]];
SPLM.Fields.FieldFormula = class extends SPLM.Fields.Field{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.FieldFormula";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;